export default {
  manageTeam: {
    active: 'Active',
    add: 'Add',
    addFailure: 'Unable to add team member, please try again',
    addingTeamMember: 'Adding team member',
    addSuccess: '{n} was added to the team',
    //dynamic use
    addTeamMember: 'Add Team Member',
    canAccessSettings: 'Can Access Settings',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteFailure: 'Unable to delete team member, please try again',
    teamMemberFailureNoConnection: 'No internet connection, please try again when your connection has been restored',
    deletePhoto: 'Delete Photo',
    deleteSuccess: '{n} was deleted from the team',
    //dynamic use
    deleteTeamMember: 'Delete team member',
    deleteTeamMemberCheck: 'Are you sure you want to delete the team member?',
    deletingTeamMember: 'Deleting team member',
    displayName: 'Display Name',
    displayNameMustBeUnique: 'Display name must be unique',
    editTeamMember: 'Edit Team Member',
    fullName: 'Full Name',
    fullNameMustBeUnique: 'Full name must be unique',
    inactive: 'Inactive',
    justNow: 'Just now',
    loadingTeamData: 'Loading team data',
    manageTeam: 'Manage Team',
    mustBeANumericValue: 'Must be a numeric value',
    noRegisteredMembers: 'There’s no added team members yet. Add the first team member now',
    noRegisteredMembersInSearch: 'There are currently no registered members in the team that match your search',
    permission: 'By pressing the Save button you are confirming that express permission of the team member to record their details was obtained.',
    photoRequired: 'Photo upload is required',
    pin: 'PIN',
    pinMustBeAtLeastNCharactersLong: 'Pin must be at least {n} characters long',
    pinMustBeUnique: 'Pin must be unique',
    pinMustNotBeMoreThanNCharactersLong: 'Pin must not be more than {n} characters long',
    save: 'Save',
    searchForTeamMember: 'Search for team member',
    selectATeam: 'Select a team',
    status: 'Status',
    takePhoto: 'Take photo',
    teamCategory: 'Team category',
    updateFailure: 'Unable to update team member, please try again',
    updateSuccess: '{n} was updated',
    //dynamic use
    updatingTeamMemberDetails: 'Updating team member details',
    uploadImage: 'Take or upload photo',
    uploadPhoto: 'Upload photo',
    warning: 'Please ensure there is at least one active team member with a pin code and access to settings.',
    weight: 'Display order',
    weightMustBeGreaterThanOrEqualToN: 'Display order must be greater than, or equal to, {n}',
    weightMustBeLessThanOrEqualToN: 'Display order must be less than, or equal to, {n}'
  }
};